import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../layout/AppLayout";
import { CheckedCircle } from "../svg/GeneralIcons";
import Button from "../button/Button";
import { FullModal } from "../../modules/world/rmc/modals/fullModal";

export const ClaimPrizeModal = () => {
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <FullModal
        className={
          " fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8]  480:max-w-[440px] 480:mx-auto"
        }
      >
        <div className="pt-16 pb-7 px-5 min-h-screen flex flex-col">
          <div className="w-full relative flex flex-col flex-grow">
            <div className=" flex-grow flex justify-between items-center flex-col h-full gap-5">
              <div className="flex-grow flex items-center flex-col w-full ">
                <CheckedCircle />
                <div className="my-12 mb-7 text-center">
                  <p className="text-black text-3xl font-semibold">
                    {" "}
                    Prize claimed!
                  </p>
                  {/* <p className="text-2xl text-black font-medium">
                    Prize claimed!
                  </p> */}
                </div>

                <div className=" w-full px-3.5 pb-4 pt-3.5 font-medium text-base text-center">
                  Head over to the Rewards section to view your reward anytime.
                </div>
              </div>
              <div className="mt-4 w-full flex flex-col gap-3">
                <Button
                  onClick={() => navigate(-1)}
                  text="Play Again"
                  className="!bg-transparent text-white"
                />
                <Button
                  onClick={() => navigate("/home", { replace: true })}
                  text="Go Home"
                />
              </div>
            </div>
          </div>
        </div>
      </FullModal>
    </AppLayout>
  );
};
